"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxActions = require("redux-actions");

var _httpActions = require("../actions/http-actions");

var _merlocActions = require("../actions/merloc-actions");

var _util = require("./util");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initialState = {
  merlocsByUuid: {},
  leadData: {
    uuid: '',
    name: {
      firstName: '',
      lastName: ''
    },
    email: '',
    reason: '',
    projectAmount: 0,
    projectTimeframe: '',
    subOrganization: ''
  }
};
exports.initialState = initialState;
var reducer = (0, _reduxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _merlocActions.CLEAR_LEAD_DATA, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    leadData: initialState.leadData
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_merlocActions.GET_APP_LEAD, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    leadData: action.payload
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_merlocActions.GET_MILESTONE_DATA, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  var uuid = action.payload.appUuid;
  return _objectSpread(_objectSpread({}, state), {}, {
    merlocsByUuid: _objectSpread(_objectSpread({}, state.merlocsByUuid), {}, (0, _defineProperty2.default)({}, uuid, _objectSpread(_objectSpread({}, state.merlocsByUuid[uuid]), {}, {
      milestoneData: action.payload
    })))
  });
}), (0, _defineProperty2.default)(_handleActions, "".concat(_merlocActions.GET_USER_MERLOCS, "_").concat(_httpActions.SUCCESS), function _(state, action) {
  if (!action.payload.length) {
    return _objectSpread(_objectSpread({}, state), {}, {
      error: '',
      loading: false
    });
  }

  var merlocsByUuid = action.payload.map(function (h) {
    var merloc = state.merlocsByUuid[h.uuid] || {};
    return _objectSpread(_objectSpread({}, merloc), {}, {
      uuid: h.uuid,
      loanNumber: h.loanNumber,
      amount: h.amount,
      reason: h.reason,
      reasonDescription: h.reasonDescription,
      rate: h.rate,
      primeRate: h.primeRate,
      term: h.term,
      rateType: h.rateType,
      payType: h.payType,
      income: h.income,
      incomePrimary: h.incomePrimary,
      incomeCoDeeders: h.incomeCoDeeders,
      incomeOther: h.incomeOther,
      incomeSources: (0, _util.mergeList)(merloc.incomeSources, h.incomeSources),
      consents: (0, _util.mergeList)(merloc.consents, h.consents),
      documents: (0, _util.mergeList)(merloc.documents, h.documents),
      disburseAccount: _objectSpread(_objectSpread({}, merloc.disburseAccount), {}, {
        uuid: h.disburseAccount.uuid,
        accountType: h.disburseAccount.accountType,
        accountTypeDescription: h.disburseAccount.accountTypeDescription,
        routingNumber: h.disburseAccount.routingNumber,
        accountNumber: h.disburseAccount.accountNumber,
        ownerName: h.disburseAccount.ownerName,
        achAccountId: h.disburseAccount.achAccountId
      }),
      autopayAccount: _objectSpread(_objectSpread({}, merloc.autopayAccount), {}, {
        uuid: h.autopayAccount.uuid,
        accountType: h.autopayAccount.accountType,
        accountTypeDescription: h.autopayAccount.accountTypeDescription,
        routingNumber: h.autopayAccount.routingNumber,
        accountNumber: h.autopayAccount.accountNumber,
        ownerName: h.autopayAccount.ownerName,
        achAccountId: h.autopayAccount.achAccountId
      }),
      plaidAssetsLinkedDate: h.plaidAssetsLinkedDate,
      property: _objectSpread(_objectSpread({}, merloc.property), {}, {
        uuid: h.property.uuid,
        type: h.property.type,
        typeDescription: h.property.typeDescription,
        street1: h.property.street1,
        street2: h.property.street2,
        city: h.property.city,
        state: h.property.state,
        zip: h.property.zip,
        ownership: h.property.ownership,
        ownershipDescription: h.property.ownershipDescription
      }),
      selectedPropertyUuid: h.selectedPropertyUuid,
      propertyHasExistingMortgage: h.propertyHasExistingMortgage,
      identityReviewed: h.identityReviewed,
      coDeedIdentityUuids: h.coDeedIdentityUuids.slice(),
      coDeedStatus: h.coDeedStatus,
      insurance: {
        floodInsured: h.insurance.floodInsured,
        homeownersInsured: h.insurance.homeownersInsured,
        complete: h.insurance.complete
      },
      hasFrozenPin: h.hasFrozenPin,
      active: h.active,
      activeForAppStart: h.activeForAppStart,
      assetDepletion: {
        retirement: h.assetDepletion.retirement,
        savings: h.assetDepletion.savings,
        investment: h.assetDepletion.investment,
        complete: h.assetDepletion.complete
      },
      incomeVerificationRequestUuid: h.incomeVerificationRequestUuid,
      organization: h.organization,
      subOrganization: h.subOrganization,
      hasHmda: h.hasHmda,
      lienAttestation: h.lienAttestation,
      initialMonthlyPayment: h.initialMonthlyPayment,
      projectAmount: action.payload.projectAmount,
      hasTShirtSize: h.hasTShirtSize,
      status: _objectSpread(_objectSpread({}, merloc.status), {}, {
        avmMatch: h.status.avmMatch,
        creditFrozen: h.status.creditFrozen,
        creditLocked: h.status.creditLocked,
        softCreditNoMatch: h.status.softCreditNoMatch,
        docVerifyStatus: h.status.docVerifyStatus,
        uwDecision: h.status.uwDecision,
        uwSubDecision: h.status.uwSubDecision,
        disclosurelistUuid: h.status.disclosurelistUuid,
        disclosurelistAppReady: h.status.disclosurelistAppReady,
        disclosurelistSummaryReady: h.status.disclosurelistSummaryReady,
        disclosurelistSummaryComplete: h.status.disclosurelistSummaryComplete,
        disclosurelistClosingReady: h.status.disclosurelistClosingReady,
        disclosurelistClosingComplete: h.status.disclosurelistClosingComplete,
        disclosurelistNotaryReady: h.status.disclosurelistNotaryReady,
        disclosurelistNotaryComplete: h.status.disclosurelistNotaryComplete,
        manualDeedSigningComplete: h.status.manualDeedSigningComplete,
        checklistStatus: h.status.checklistStatus,
        manualNotary: h.status.manualNotary,
        hasAal: h.status.hasAal,
        manualDeed: h.status.manualDeed,
        participantAcceptComplete: h.status.participantAcceptComplete,
        primaryParticipantAcceptComplete: h.status.primaryParticipantAcceptComplete,
        contextReady: h.status.contextReady,
        contextLeadReady: h.status.contextLeadReady,
        firstLien: h.status.firstLien,
        cancellationStatus: h.status.cancellationStatus,
        dtiDecline: h.status.dtiDecline,
        creditScoreDecline: h.status.creditScoreDecline,
        incomeVerificationResultUuid: h.status.incomeVerificationResultUuid,
        canIncomeVerify: !h.incomeVerificationRequestUuid || h.status.incomeVerificationResultUuid === h.incomeVerificationRequestUuid
      }),
      maritalStatus: h.maritalStatus,
      requestedManualNotaryTime: h.requestedManualNotaryTime,
      requestedManualNotaryAddress: h.requestedManualNotaryAddress,
      auditFields: _objectSpread(_objectSpread({}, merloc.auditFields), {}, {
        createdDate: h.auditFields.createdDate
      })
    });
  }).reduce(function (result, h) {
    var keyValue = {};
    keyValue[h.uuid] = h;
    return Object.assign({}, result, keyValue);
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    merlocsByUuid: _objectSpread(_objectSpread({}, state.merlocsByUuid), merlocsByUuid),
    loading: false,
    error: ''
  });
}), _handleActions), initialState);
var _default = reducer;
exports.default = _default;